import CommuteTable from "./Table";
import "./index.css";
const CommuteContents = ({ businessId }) => {
  return (
    <div className="commute-contents">
      <CommuteTable businessId={businessId} />
    </div>
  );
};

export default CommuteContents;
